import { createSlice } from '@reduxjs/toolkit';
import { PaymentState } from './state';
import reducers from './reducers';

const initialState: PaymentState = {
  virtual_account: null,
  cards: [],
  select_card: null,
  select_virtual_account: null,
  tax_profile: null,
  banks: null,
};

const payments = createSlice({
  name: 'payments',
  initialState,
  reducers,
});

export const paymentsActions = { ...payments.actions };
export default payments;
